import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { GuardianLanguageProvider } from './context/GuardianLanguageContext';
import GuardianAuth      from './pages/GuardianAuth';
import GuardianDashboard from './pages/GuardianDashboard';
import GuardianReports   from './pages/GuardianReports';
import GuardianSettings  from './pages/GuardianSettings';
import StudentDetail     from './pages/StudentDetail';
import ChooseRole        from './pages/ChooseRole';
import StudentAuth       from './pages/StudentAuth';
import StudentOnboarding from './pages/StudentOnboarding';
import StudentDashboard  from './pages/StudentDashboard';
import StudentSettings   from './pages/StudentSettings';
import SubjectSelector    from './pages/SubjectSelector';
import ExplanationScreen  from './pages/ExplanationScreen';
import QuizScreen         from './pages/QuizScreen';
import QuizHub            from './pages/QuizHub';
import Results            from './pages/Results';
import SubjectUnitsPage   from './pages/SubjectUnitsPage';
import Flashcards         from './pages/Flashcards';
import Challenges         from './pages/Challenges';
import Achievements       from './pages/Achievements';
import ErrorBoundary      from './components/ErrorBoundary';
import { useSessionHeartbeat } from './api/useSessionHeartbeat';
import { isPinStillValid } from './api/pinSession';

function GuardianLayout() {
  return <GuardianLanguageProvider><Outlet /></GuardianLanguageProvider>;
}

function StudentLayout() {
  return <LanguageProvider><Outlet /></LanguageProvider>;
}

export default function App() {
  return (
    <ErrorBoundary>
    <LanguageProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/"          element={<RootRedirect />} />
        <Route path="/choose-role" element={<ChooseRole />} />

        <Route element={<GuardianLayout />}>
          <Route path="/guardian/auth"                element={<GuardianAuth />} />
          <Route path="/guardian/dashboard"           element={<GuardianDashboard />} />
          <Route path="/guardian/reports"             element={<GuardianReports />} />
          <Route path="/guardian/settings"            element={<GuardianSettings />} />
          <Route path="/guardian/student/:student_id" element={<StudentDetail />} />
        </Route>

        <Route element={<StudentLayout />}>
          <Route path="/student/auth" element={<StudentAuth />} />
          <Route element={<StudentPrivateRoute />}>
            <Route path="/student/onboarding"    element={<StudentOnboarding />} />
            <Route path="/student/dashboard"     element={<StudentDashboard />} />
            <Route path="/student/settings"      element={<StudentSettings />} />
            <Route path="/student/subjects"      element={<SubjectSelector />} />
            <Route path="/student/explanation"   element={<ExplanationScreen />} />
            <Route path="/student/quiz"          element={<QuizScreen />} />
            <Route path="/student/quizzes"       element={<QuizHub />} />
            <Route path="/student/results"       element={<Results />} />
            <Route path="/student/subject-units" element={<SubjectUnitsPage />} />
            <Route path="/student/flashcards"    element={<Flashcards />} />
            <Route path="/student/challenges"    element={<Challenges />} />
            <Route path="/student/achievements"  element={<Achievements />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/choose-role" replace />} />
      </Routes>
    </BrowserRouter>
    </LanguageProvider>
    </ErrorBoundary>
  );
}

function StudentPrivateRoute() {
  useSessionHeartbeat("student");
  const token      = localStorage.getItem('student_token');
  if (!token)            return <Navigate to="/student/auth" replace />;
  if (!isPinStillValid()) return <Navigate to="/student/auth" replace />;
  return <Outlet />;
}

function RootRedirect() {
  window.location.replace('/jahbath-landing.html');
  return null;
}

function ComingSoon() {
  const lang = localStorage.getItem('jahbath_student_lang') || 'ar';
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', fontSize: 28, color: '#6b7280' }}>
      {lang === 'ar' ? 'قريباً' : 'Coming Soon'}
    </div>
  );
}